/* eslint-disable @typescript-eslint/naming-convention */
export const processMatchLineupResponse = (matchLineupResponse: any, previousLineup: any) => {
    const isPossibleLineups = Boolean(
        matchLineupResponse?.team1_possible_lineup?.length &&
            !matchLineupResponse?.team1_lineup?.length &&
            matchLineupResponse.team2_possible_lineup?.length &&
            !matchLineupResponse?.team2_lineup?.length,
    )

    let team1Lineup = matchLineupResponse?.team1_lineup
    let team1Formation = matchLineupResponse?.team1_formation
    let team1IsPreviousLineup = false

    let team2Lineup = matchLineupResponse?.team2_lineup
    let team2Formation = matchLineupResponse?.team2_formation
    let team2IsPreviousLineup = false

    if (!matchLineupResponse?.team1_lineup.length) {
        team1Lineup = isPossibleLineups ? matchLineupResponse?.team1_possible_lineup : previousLineup?.team1?.lineup

        team1Formation = isPossibleLineups
            ? matchLineupResponse?.team1_possible_formation
            : previousLineup?.team1?.formation

        if (!isPossibleLineups && previousLineup?.team1?.lineup?.length) {
            team1IsPreviousLineup = true
        }
    }

    if (!matchLineupResponse?.team2_lineup.length) {
        team2Lineup = isPossibleLineups ? matchLineupResponse?.team2_possible_lineup : previousLineup?.team2?.lineup

        team2Formation = isPossibleLineups
            ? matchLineupResponse?.team2_possible_formation
            : previousLineup?.team2?.formation

        if (!isPossibleLineups && previousLineup?.team2?.lineup?.length) {
            team2IsPreviousLineup = true
        }
    }

    return {
        isPossibleLineups,
        team1: {
            lineup: team1Lineup,
            formation: team1Formation,
            isPreviousLineup: team1IsPreviousLineup,
        },
        team2: {
            lineup: team2Lineup,
            formation: team2Formation,
            isPreviousLineup: team2IsPreviousLineup,
        },
    }
}

export const transformLineupData = (lineup: any[], isPossibleLineups?: boolean) => {
    if (!lineup || lineup.length === 0) {
        return Array.from({ length: 11 }, () => ({ starter: true, captain: false }))
    }

    const prettyLineup = lineup.map(player => ({
        id: player.player_id,
        name: player.name,
        shirt_number: player.shirt_number,
        order: player.formation_place,
        starter: !player.substitute,
        captain: player.captain,
    }))

    const filteredPrettyLineup = isPossibleLineups ? prettyLineup?.filter(player => player.starter) : prettyLineup

    return filteredPrettyLineup
}

export const checkIsLineupWithoutFormation = (lineup: any[], formation: string | null) =>
    Boolean(lineup?.length && !formation)

export const checkAreAllPlayersIn = lineup => lineup.flat().filter(p => p !== null && p.name && p.starter).length === 11
